import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';

export default class NewBackupCodesController extends Controller {
  @service masq;
  @service alerts;
  @service router;

  serverErrors = null;

  @action
  resetServerErrors() {
    this.set('serverErrors', []);
  }

  @action
  done() {
    return this.router.transitionTo('settings.personal.security');
  }
}
